import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=4a3db3ea&scoped=true&"
import script from "./Units.vue?vue&type=script&lang=js&"
export * from "./Units.vue?vue&type=script&lang=js&"
import style0 from "./Units.vue?vue&type=style&index=0&id=4a3db3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3db3ea",
  null
  
)

export default component.exports